import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "In the next iteration, the left speaker compensates the crosstalk at the left ear (violet, 3) and produces a new crosstalk at the right ear (blue, 3’). The level of the crosstalk deceases for each interation.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/21/principle/principle-4.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
